import { useEffect } from 'react';

import { useSnackbar } from 'notistack';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

// eslint-disable-next-line prettier/prettier
import type { State } from './Store';

const HttpsCheck = ({ children, translate }) => {
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    const { origin, protocol } = window.location;
    if (!protocol.startsWith('https') && !origin.includes('localhost')) {
      enqueueSnackbar(translate('Security_NonHttpsMessage'), {
        variant: 'error',
        persist: true,
      });
    }
  }, []);
  return children;
};

const mapStateToProps = (state: State) => ({
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps)(HttpsCheck);
